import React, { useEffect, useState } from "react";
import { reset, change } from "redux-form";
import { useDispatch } from "react-redux";
import _ from "lodash";
import Create from "./components/Create";
import validate from "./components/validate";
import { createUserForCompany } from "containers/User/containers/Create/actions";
import { getEventPublic } from "containers/Events/containers/Report/actions";
import ls from "Localization";

const ExpositorRegisterId = ({ history }) => {
	const [error, setError] = useState("");
	const dispatch = useDispatch();

	const [events, setEvents] = useState([]);

	useEffect(() => {
		dispatch(
			getEventPublic(0, 100, null, "createdAt", false, true, (err, data) => {
				if (err) {
					console.log(err);
				} else {
					setEvents(data);
				}
			})
		);
	}, []);

	const onSubmit = values => {
		const errors = validate(values);

		if (!_.isEmpty(errors)) {
			setError("Por favor, preencha todos os campos corretamente.");
			return;
		}

		if (values.type === "professional") {
			if (values.architect) {
				values.profession = "Arquiteto";
			}

			if (values.decorator) {
				values.interiorDecorator = "Decorador de interiores";
			}
		}

		const data = {
			firstName: values.name,
			lastName: values.lastname,
			document: values.cpf,
			email: values.email,
			phoneNumber: values.phone && `+55${values.phone.match(/\d/g).join("")}`,
			birthDate: values.birthDate && values.birthDate,
			birthPlace: values.birthPlace,
			role: "USER",
			gender: values.gender && values.gender.value,
			profession: values.profession || undefined,

			companyName:
				values.companyName ||
				(values.feapaes
					? `${ls[values.type]} FEAPAES`
					: values.apae
					? `${ls[values.type]} APAE`
					: values.provincial
					? `${ls[values.type]} Estadual`
					: values.region
					? `${ls[values.type]} Regional`
					: values.local
					? `${ls[values.type]} Local`
					: ls[values.type] || undefined),
			cnpj: values.cnpj || undefined,
			type: values.type,
			pcdFamily: values.pcdFamily,
			pcd: values.pcd,
			specialNeeds: values.specialNeeds,
			events: Object.keys(values.events).filter(c => values.events[c])
		};

		if (values.city || values.state) {
			data.address = {
				city: values.city,
				state: values.state
			};
		}

		if (values.type === "coordinator") {
			data.companyName = "";
			data.profession = "";

			if (values.provincial) {
				data.companyName = `${values.companyNameProvincial} Estadual`;
				data.profession = `${values.professionProvincial} Estadual`;
			}

			if (values.region) {
				if (values.provincial) {
					data.companyName += ` | ${values.companyNameRegion} Regional`;
					data.profession += ` | ${values.professionRegion} Regional`;
				} else {
					data.companyName = `${values.companyNameRegion} Regional`;
					data.profession = `${values.professionRegion} Regional`;
				}
			}

			if (values.local) {
				if (values.provincial || values.region) {
					data.companyName += ` | ${values.companyNameLocal} Local`;
					data.profession += ` | ${values.professionLocal} Local`;
				} else {
					data.companyName = `${values.companyNameLocal} Local`;
					data.profession = `${values.professionLocal} Local`;
				}
			}
		}

		console.log(data);

		try {
			dispatch(change("expositor_form", "loading", true));
			dispatch(
				createUserForCompany(values.type, data, (err, user) => {
					if (err) {
						console.log(err);
					} else {
						dispatch(reset("expositor_form"));
						dispatch(change("expositor_form", "done", true));
					}

					dispatch(change("expositor_form", "loading", false));
				})
			);
		} catch (err) {
			console.error("Houve um erro na submissão:", err);

			dispatch(change("expositor_form", "loading", false));
		}
	};

	const handleReload = () => {
		location.reload();
	};

	return (
		<div className="account">
			<div className="account__wrapper">
				<div
					className="account__card"
					style={{ paddingBottom: 8, maxWidth: 630 }}
				>
					<div className="account__logo__head">
						<div className="account__sub_logo" />
					</div>

					{error ? (
						<div>
							<h3 className="account__title">{error}</h3>
							<button
								type="button"
								className="btn btn-primary account__btn account__btn--small"
								onClick={() => {
									handleReload();
								}}
							>
								Voltar
							</button>
						</div>
					) : (
						<Create onSubmit={onSubmit} history={history} events={events} />
					)}

					<div
						className="account__logo__head"
						style={{ marginBottom: 8, justifyContent: "space-evenly" }}
					>
						<div className="account__logo" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExpositorRegisterId;
